import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledDropdown } from "reactstrap";
import BreadCrumb from "../../../components/common/bread-crumb";
import TableModify from "../../../components/common/table-modify";
import Select from "react-select";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ConfigData from '../../../config.json';
import { handlerRespError } from "../../../components/utility/handler_resp";
import { useHistory } from "react-router-dom";
import MenuTap from "../../../components/common/menu-tap";

const PositionList = () => {
    const [isShowModal, setIsShowModal] = useState();
    const [dataTable, setDataTable] = useState([]);
    const [dataDepartment, setDataDepartment] = useState([]);
    const [dataSubDepartment, setDataSubDepartment] = useState([]);
    const [dataDivision, setDataDivision] = useState([]);
    const [dataSubDivision, setDataSubDivision] = useState([]);
    const [dataSection, setDataSection] = useState([]);
    const [dataSubSection, setDataSubSection] = useState([]);
    const [selectedBusinessUnit, setSelectedBusinessUnit] = useState("");
    const [ddlBusinessUnit, setDdlBusinessUnit] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [ddlDepartment, setDdlDepartment] = useState([]);
    const [selectedSubDepartment, setSelectedSubDepartment] = useState("");
    const [ddlSubDepartment, setDdlSubDepartment] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState("");
    const [ddlDivision, setDdlDivision] = useState([]);
    const [selectedSubDivision, setSelectedSubDivision] = useState("");
    const [ddlSubDivision, setDdlSubDivision] = useState([]);
    const [selectedSection, setSelectedSection] = useState("");
    const [ddlSection, setDdlSection] = useState([]);
    const [selectedSubSection, setSelectedSubSection] = useState("");
    const [ddlSubSection, setDdlSubSection] = useState([]);
    const [dataDetail, setDataDetail] = useState({
        id: 0,
        id_business_unit: "",
        id_department: "",
        id_sub_department: "",
        id_division: "",
        id_sub_division: "",
        id_section: "",
        id_sub_section: "",
        code: "",
        name: "",
        remark: ""
    });
    const history = useHistory();

    useEffect(() => {
        LoadDataTable();
        LoadDataDdlBusinessUnit();
        LoadDataDepartment();
        LoadDataSubDepartment();
        LoadDataDivision();
        LoadDataSubDivision();
        LoadDataSection();
        LoadDataSubSection();
    }, []);

    const column = [
        {
            key: "id",
            name: <span className='font-weight-bold fs-13'>No.</span>,
            cell: (row, index) => index+1,
            width: "5%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: false
        },
        {
            key: "name_business_unit",
            name: <span className='font-weight-bold fs-13'>Business unit</span>,
            cell: (row, index) => row.name_business_unit,
            width: "12%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name_department",
            name: <span className='font-weight-bold fs-13'>Department</span>,
            cell: (row, index) => row.name_department,
            width: "12%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name_sub_department",
            name: <span className='font-weight-bold fs-13'>Sub department</span>,
            cell: (row, index) => row.name_sub_department,
            width: "12%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name_division",
            name: <span className='font-weight-bold fs-13'>Division</span>,
            cell: (row, index) => row.name_division,
            width: "12%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name_sub_division",
            name: <span className='font-weight-bold fs-13'>Sub division</span>,
            cell: (row, index) => row.name_sub_division,
            width: "12%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name_section",
            name: <span className='font-weight-bold fs-13'>Section</span>,
            cell: (row, index) => row.name_section,
            width: "12%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name_sub_section",
            name: <span className='font-weight-bold fs-13'>Sub section</span>,
            cell: (row, index) => row.name_sub_section,
            width: "12%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "code",
            name: <span className='font-weight-bold fs-13'>Code</span>,
            cell: (row, index) => row.code,
            width: "8%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name",
            name: <span className='font-weight-bold fs-13'>Name</span>,
            cell: (row, index) => row.name,
            width: "15%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "action",
            name: <span className='font-weight-bold fs-13'></span>,
            cell: (row, index) => {
                return(
                    <UncontrolledDropdown key={index}>
                        <DropdownToggle tag="button" className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="ri-more-2-fill"></i></DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <li>
                                <DropdownItem onClick={() => onClickUpdate(row)}>
                                    <i className="ri-pencil-fill"></i> Edit
                                </DropdownItem>
                            </li>
                            <li>
                                <DropdownItem onClick={() => onClickDelete(row.id)}>
                                    <i className="ri-delete-bin-line"></i> Delete
                                </DropdownItem>
                            </li>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                )
            },
            width: "7%",
            classHeader: "text-start",
            classBody: "text-end",
            sortable: false
        }
    ];

    const onClickAdd = () => {
        validation.resetForm();
        // setDdlDepartment([]);
        // setDdlSubDepartment([]);
        // setDdlDivision([]);
        // setDdlSubDivision([]);
        // setDdlSection([]);
        // setDdlSubSection([]);
        setDdlDepartment(dataDepartment);
        setDdlSubDepartment(dataSubDepartment);
        setDdlDivision(dataDivision);
        setDdlSubDivision(dataSubDivision);
        setDdlSection(dataSection);
        setDdlSubSection(dataSubSection);
        setSelectedBusinessUnit(null);
        setSelectedDepartment(null);
        setSelectedSubDepartment(null);
        setSelectedDivision(null);
        setSelectedSubDivision(null);
        setSelectedSection(null);
        setSelectedSubSection(null);
        setDataDetail({
            id: 0,
            id_business_unit: "",
            id_department: "",
            id_sub_department: "",
            id_division: "",
            id_sub_division: "",
            id_section: "",
            id_sub_section: "",
            code: "",
            name: "",
            remark: ""
        });
        setIsShowModal(!isShowModal);
    };

    const onClickUpdate= (data) => {
        validation.resetForm();
        // setDdlDepartment(dataDepartment.filter((e) => e.id_business_unit === data.id_business_unit.toString()));
        // setDdlSubDepartment(dataSubDepartment.filter((e) => e.id_department === data.id_department.toString()));
        // setDdlDivision(dataDivision.filter((e) => e.id_sub_department === data.id_sub_department.toString()));
        // setDdlSubDivision(dataSubDivision.filter((e) => e.id_division === data.id_division.toString()));
        // setDdlSection(dataSection.filter((e) => e.id_sub_division === data.id_sub_division.toString()));
        // setDdlSubSection(dataSubSection.filter((e) => e.id_section === data.id_section.toString()));
        setDdlDepartment(dataDepartment);
        setDdlSubDepartment(dataSubDepartment);
        setDdlDivision(dataDivision);
        setDdlSubDivision(dataSubDivision);
        setDdlSection(dataSection);
        setDdlSubSection(dataSubSection);
        setSelectedBusinessUnit(ddlBusinessUnit.find(x => x.value === data.id_business_unit.toString()));
        setSelectedDepartment(dataDepartment.find(x => x.value === data.id_department.toString()));
        setSelectedSubDepartment(dataSubDepartment.find(x => x.value === data.id_sub_department.toString()));
        setSelectedDivision(dataDivision.find(x => x.value === data.id_division.toString()));
        setSelectedSubDivision(dataSubDivision.find(x => x.value === data.id_sub_division.toString()));
        setSelectedSection(dataSection.find(x => x.value === data.id_section.toString()));
        setSelectedSubSection(dataSubSection.find(x => x.value === data.id_sub_section.toString()));
        setDataDetail({
            id: data.id,
            code: data.code,
            id_business_unit: data.id_business_unit,
            id_department: data.id_department,
            id_sub_department: data.id_sub_department,
            id_division: data.id_division,
            id_sub_division: data.id_sub_division,
            id_section: data.id_section,
            id_sub_section: data.id_sub_section,
            name: data.name,
            remark: data.remark
        });
        setIsShowModal(!isShowModal);
    };

    const onClickDelete = (id) => {
        Swal.fire({
            title: 'Are you sure ?',
            text: 'Once you delete, you can not undo it!',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            confirmButtonColor: '#dc3741',
        }).then((result) => {
            if(result.isConfirmed){
                DeletePosition(id);
            }
        });
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_business_unit: dataDetail.id_business_unit || "",
            id_department: dataDetail.id_department || "",
            id_sub_department: dataDetail.id_sub_department || "",
            id_division: dataDetail.id_division || "",
            id_sub_division: dataDetail.id_sub_division || "",
            id_section: dataDetail.id_section || "",
            id_sub_section: dataDetail.id_sub_section || "",
            code: dataDetail.code || "",
            name:  dataDetail.name || "",
            remark: dataDetail.remark || "",
        },
        validationSchema: Yup.object({
            id_business_unit: Yup.string().required("Please select a business unit"),
            // id_department: Yup.string().required("Please select a department"),
            // id_sub_department: Yup.string().required("Please select a sub department"),
            // id_division: Yup.string().required("Please select a division"),
            // id_sub_division: Yup.string().required("Please select a sub division"),
            // id_section: Yup.string().required("Please select a section"),
            // id_sub_section: Yup.string().required("Please select a sub section"),
            code: Yup.string().required("Please enter a Code"),
            name: Yup.string().required("Please enter a Name"),
        }),
        onSubmit: (values) => {
            values.id_business_unit = (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;
            values.id_department = (values.id_department !== "") ? parseInt(values.id_department) : 0;
            values.id_sub_department = (values.id_sub_department !== "") ? parseInt(values.id_sub_department) : 0;
            values.id_division = (values.id_division !== "") ? parseInt(values.id_division) : 0;
            values.id_sub_division = (values.id_sub_division !== "") ? parseInt(values.id_sub_division) : 0;
            values.id_section = (values.id_section !== "") ? parseInt(values.id_section) : 0;
            values.id_sub_section = (values.id_sub_section !== "") ? parseInt(values.id_sub_section) : 0;
            if(values.id > 0){
                UpdatePosition(values);
            }else{
                AddPosition(values);
            }
        }
    });

    const LoadDataTable = () => {
        let url = ConfigData.API_URL + "position/?status=1";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                setDataTable(respData.data);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDdlBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlBusinessUnit(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDepartment = () => {
        let url = ConfigData.API_URL + "department/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                    };
                });
                setDataDepartment(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubDepartment = () => {
        let url = ConfigData.API_URL + "sub-department/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                    };
                });
                setDataSubDepartment(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDivision = () => {
        let url = ConfigData.API_URL + "division/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                    };
                });
                setDataDivision(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubDivision = () => {
        let url = ConfigData.API_URL + "sub-division/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                    };
                });
                setDataSubDivision(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSection = () => {
        let url = ConfigData.API_URL + "section/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                        id_sub_division: e.id_sub_division.toString(),
                    };
                });
                setDataSection(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataSubSection = () => {
        let url = ConfigData.API_URL + "sub-section/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                let arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                        id_business_unit: e.id_business_unit.toString(),
                        id_department: e.id_department.toString(),
                        id_sub_department: e.id_sub_department.toString(),
                        id_division: e.id_division.toString(),
                        id_sub_division: e.id_sub_division.toString(),
                        id_section: e.id_section.toString(),
                    };
                });
                setDataSubSection(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const AddPosition = (data) => {
        let url = ConfigData.API_URL + "position/";
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.post(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                setIsShowModal(!isShowModal);
                Swal.fire({
                    icon: 'success',
                    title: 'Add data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to add data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const UpdatePosition = (data) => {
        let url = ConfigData.API_URL + "position/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.put(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                setIsShowModal(false);
                Swal.fire({
                    icon: 'success',
                    title: 'Edit data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to edit data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const DeletePosition = (id) => {
        let url = ConfigData.API_URL + "position/" + id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.delete(url, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                Swal.fire({
                    icon: 'success',
                    title: 'Delete data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };
    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Position structure" pageTitle="Data setting" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                    <MenuTap type="position" idActive="1" />
                                    <TableModify data={dataTable} column={column} rowPerPage={25} onClickAdd={onClickAdd} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* Modal Add and Edit */}
            <Modal id="modalPosition"
                isOpen={isShowModal}
                toggle={() => { setIsShowModal(!isShowModal); }}
                backdrop={'static'}
                centered
            >
                <ModalHeader id="modalPositionHeader" 
                    className="modal-title"
                    toggle={() => { setIsShowModal(!isShowModal); }}
                >
                    {(dataDetail.id <= 0) ? "Create position" : "Edit position"}
                </ModalHeader>
                <ModalBody>
                    <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlBusinessUnit">Business unit</Label>
                                    <Select id="ddlBusinessUnit"
                                        name="id_business_unit"
                                        value={selectedBusinessUnit}
                                        onChange={(selected) => {
                                            let id_business_unit = (selected !== null) ? selected.value : "";
                                            // setDdlDepartment(dataDepartment.filter((e) => e.id_business_unit === id_business_unit));
                                            // setDdlSubDepartment([]);
                                            // setDdlDivision([]);
                                            // setDdlSubDivision([]);
                                            // setDdlSection([]);
                                            // setDdlSubSection([]);
                                            setSelectedBusinessUnit(selected);
                                            // setSelectedDepartment(null);
                                            // setSelectedSubDepartment(null);
                                            // setSelectedDivision(null);
                                            // setSelectedSubDivision(null);
                                            // setSelectedSection(null);
                                            // setSelectedSubSection(null);
                                            validation.handleChange('id_business_unit')(id_business_unit);
                                            // validation.handleChange('id_department')("");
                                            // validation.handleChange('id_sub_department')("");
                                            // validation.handleChange('id_division')("");
                                            // validation.handleChange('id_sub_division')("");
                                            // validation.handleChange('id_section')("");
                                            // validation.handleChange('id_sub_section')("");
                                        }}
                                        options={ddlBusinessUnit}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_business_unit && validation.errors.id_business_unit ? true : false }
                                    />
                                    { validation.touched.id_business_unit && validation.errors.id_business_unit ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_business_unit}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlDepartment">Department</Label>
                                    <Select id="ddlDepartment"
                                        name="id_department"
                                        value={selectedDepartment}
                                        onChange={(selected) => {
                                            let id_department = (selected !== null) ? selected.value : "";
                                            // setDdlSubDepartment(dataSubDepartment.filter((e) => e.id_department === id_department));
                                            // setDdlDivision([]);
                                            // setDdlSubDivision([]);
                                            // setDdlSection([]);
                                            // setDdlSubSection([]);
                                            setSelectedDepartment(selected);
                                            // setSelectedSubDepartment(null);
                                            // setSelectedDivision(null);
                                            // setSelectedSubDivision(null);
                                            // setSelectedSection(null);
                                            // setSelectedSubSection(null);
                                            validation.handleChange('id_department')(id_department);
                                            // validation.handleChange('id_sub_department')("");
                                            // validation.handleChange('id_division')("");
                                            // validation.handleChange('id_sub_division')("");
                                            // validation.handleChange('id_section')("");
                                            // validation.handleChange('id_sub_section')("");
                                        }}
                                        options={ddlDepartment}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_department && validation.errors.id_department ? true : false }
                                    />
                                    { validation.touched.id_department && validation.errors.id_department ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_department}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlSubDepartment">Sub department</Label>
                                    <Select id="ddlSubDepartment"
                                        name="id_sub_department"
                                        value={selectedSubDepartment}
                                        onChange={(selected) => {
                                            let id_sub_department = (selected !== null) ? selected.value : "";
                                            // setDdlDivision(dataDivision.filter((e) => e.id_sub_department === id_sub_department));
                                            // setDdlSubDivision([]);
                                            // setDdlSection([]);
                                            // setDdlSubSection([]);
                                            setSelectedSubDepartment(selected);
                                            // setSelectedDivision(null);
                                            // setSelectedSubDivision(null);
                                            // setSelectedSection(null);
                                            // setSelectedSubSection(null);
                                            validation.handleChange('id_sub_department')(id_sub_department);
                                            // validation.handleChange('id_division')("");
                                            // validation.handleChange('id_sub_division')("");
                                            // validation.handleChange('id_section')("");
                                            // validation.handleChange('id_sub_section')("");
                                        }}
                                        options={ddlSubDepartment}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_sub_department && validation.errors.id_sub_department ? true : false }
                                    />
                                    { validation.touched.id_sub_department && validation.errors.id_sub_department ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_sub_department}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlDivision">Division</Label>
                                    <Select id="ddlDivision"
                                        name="id_division"
                                        value={selectedDivision}
                                        onChange={(selected) => {
                                            let id_division = (selected !== null) ? selected.value : "";
                                            // setDdlSubDivision(dataSubDivision.filter((e) => e.id_division === id_division));
                                            // setDdlSection([]);
                                            // setDdlSubSection([]);
                                            setSelectedDivision(selected);
                                            // setSelectedSubDivision(null);
                                            // setSelectedSection(null);
                                            // setSelectedSubSection(null);
                                            validation.handleChange('id_division')((selected !== null) ? selected.value : "");
                                            // validation.handleChange('id_sub_division')("");
                                            // validation.handleChange('id_section')("");
                                            // validation.handleChange('id_sub_section')("");
                                        }}
                                        options={ddlDivision}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_division && validation.errors.id_division ? true : false }
                                    />
                                    { validation.touched.id_division && validation.errors.id_division ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_division}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlSubDivision">Sub Division</Label>
                                    <Select id="ddlSubDivision"
                                        name="id_sub_division"
                                        value={selectedSubDivision}
                                        onChange={(selected) => {
                                            let id_sub_division = (selected !== null) ? selected.value : "";
                                            // setDdlSection(dataSection.filter((e) => e.id_sub_division === id_sub_division));
                                            // setDdlSubSection([]);
                                            setSelectedSubDivision(selected);
                                            // setSelectedSection(null);
                                            // setSelectedSubSection(null);
                                            validation.handleChange('id_sub_division')(id_sub_division);
                                            // validation.handleChange('id_section')("");
                                            // validation.handleChange('id_sub_section')("");
                                        }}
                                        options={ddlSubDivision}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_sub_division && validation.errors.id_sub_division ? true : false }
                                    />
                                    { validation.touched.id_sub_division && validation.errors.id_sub_division ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_sub_division}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlSection">Section</Label>
                                    <Select id="ddlSection"
                                        name="id_section"
                                        value={selectedSection}
                                        onChange={(selected) => {
                                            let id_section = (selected !== null) ? selected.value : "";
                                            // setDdlSubSection(dataSubSection.filter((e) => e.id_section === id_section));
                                            setSelectedSection(selected);
                                            // setSelectedSubSection(null);
                                            validation.handleChange('id_section')(id_section);
                                            // validation.handleChange('id_sub_section')("");
                                        }}
                                        options={ddlSection}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_section && validation.errors.id_section ? true : false }
                                    />
                                    { validation.touched.id_section && validation.errors.id_section ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_section}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlSubSection">Sub section</Label>
                                    <Select id="ddlSubSection"
                                        name="id_sub_section"
                                        value={selectedSubSection}
                                        onChange={(selected) => {
                                            setSelectedSubSection(selected);
                                            validation.handleChange('id_sub_section')((selected !== null) ? selected.value : "");
                                        }}
                                        options={ddlSubSection}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_sub_section && validation.errors.id_sub_section ? true : false }
                                    />
                                    { validation.touched.id_sub_section && validation.errors.id_sub_section ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_sub_section}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="txtCode">Code</Label>
                                    <Input id="txtCode" 
                                        name="code"
                                        placeholder="Code"
                                        type="text"
                                        className="from-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.code || ""}
                                        invalid={ validation.touched.code && validation.errors.code ? true : false }
                                    />
                                    { validation.touched.code && validation.errors.code ? 
                                        ( <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="txtName">Name</Label>
                                    <Input id="txtName" 
                                        name="name"
                                        placeholder="Name"
                                        type="text"
                                        className="from-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.name || ""}
                                        invalid={ validation.touched.name && validation.errors.name ? true : false }
                                    />
                                    { validation.touched.name && validation.errors.name ? 
                                        ( <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="txtRemark">Remark</Label>
                                    <Input id="txtRemark" 
                                        name="remark"
                                        placeholder="Remark"
                                        type="textarea"
                                        className="from-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.remark || ""}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <Button color="primary" type="button" onClick={() => setIsShowModal(false) } >
                                    Close
                                </Button>
                                <Button className="float-end" color="success" type="submit">
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default PositionList;